/**
 * Per the AI Feature Instrumentation for KRs contract with DE/DS. Add an entry per skill/agent
 * declaring which KR(s) it counts toward and its service/ops classification. Key must be a
 * skillName, minionId, plugin name, or agentExternalConfigReference. Matching is substring-based
 * (see @atlassian/conversation-assistant's mciKrAttributes.ts): a key matches if the identifier
 * contains it, not exact equality.
 */
export type MciKrConfigEntry = {
	serviceOrOps: 'service' | 'ops';
	countsTowardMciPlusKr?: boolean;
	countsTowardAiAdoptedKr?: boolean;
};

export const MCI_KR_SERVICE_OPS_CONFIG: Record<string, MciKrConfigEntry> = {
	// Agent example — matched via agentExternalConfigReference
	jsm_example_agent: {
		serviceOrOps: 'ops',
		countsTowardMciPlusKr: true,
	},
	// Skill example — matches any skill/minion name containing this substring
	jsm_atlassian_work_item: {
		serviceOrOps: 'service',
		countsTowardMciPlusKr: true,
		countsTowardAiAdoptedKr: true,
	},
	SurveysStratusMinion: {
		serviceOrOps: 'service',
		countsTowardMciPlusKr: true,
		countsTowardAiAdoptedKr: true,
	},
	jsm_service_triage_agent: {
		serviceOrOps: 'service',
		countsTowardMciPlusKr: true,
		countsTowardAiAdoptedKr: true,
	},
};
